import React, { useCallback, useMemo } from "react";

import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import RankedQueryCard from "../../charts/RankedQueryCard";
import { offersSubscriptionsQuery } from "../offerAnalytics.queries";
import { buildSubscriptionsByOffer } from "../offerAnalytics.utils";
import useMissingOfferLabel from "../useMissingOfferLabel";

import type { JSX } from "react";

import type { GetOffersSubscriptionsResponse } from "@/src/api/StatsAPI.types";

import type { ChartSeries } from "../../charts/charts.types";
import type {
  CountSeriesKey,
  OfferAnalyticsFilterProps,
} from "../offerAnalytics.types";

function SubscriptionsByOfferCard({
  filters,
}: OfferAnalyticsFilterProps): JSX.Element {
  const { projectSlug } = useParams<{ projectSlug: string }>();
  const { t } = useTranslation("editor-analytics");
  const getMissingOfferLabel = useMissingOfferLabel();

  const seriesList = useMemo(
    (): ChartSeries<CountSeriesKey>[] => [
      {
        key: "count",
        label: t("offerAnalytics.series.subscriptions"),
        color: "var(--chart-1)",
      },
    ],
    [t],
  );
  const buildRankedList = useCallback(
    (response: GetOffersSubscriptionsResponse | undefined) =>
      buildSubscriptionsByOffer(response?.data ?? [], getMissingOfferLabel),
    [getMissingOfferLabel],
  );

  return (
    <RankedQueryCard
      buildRankedList={buildRankedList}
      query={offersSubscriptionsQuery(projectSlug, filters)}
      seriesList={seriesList}
      title={t("offerAnalytics.charts.subscriptionsByOffer")}
    />
  );
}

export default SubscriptionsByOfferCard;
